import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Upload } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  canUploadDocument: boolean
  url?: string
  removePadding?: boolean
}

const DocumentsResourceHeader = ({
  title,
  canUploadDocument,
  url,
  removePadding = false,
}: Props) => {
  const navigate = useNavigate()
  let action = undefined

  if (canUploadDocument && url) {
    action = {
      label: i18n.t('documents.action'),
      icon: Upload,
      onClick: () => navigate(url),
    }
  }

  const header = <ResourceHeader title={title} primaryAction={action} />

  if (!removePadding) return header

  return <Box style={{ margin: '-20px' }}>{header}</Box>
}

export default DocumentsResourceHeader
